<template>
  <div class="o-page">

    <app-navigation :currentSpace="currentSpace"></app-navigation>

    <main class="o-page__main">

      <template v-for="card in page.layout">
        <component v-if="typeof cards[card.id] !== 'undefined'"
                   :key="card.id"
                   :is="'card-'+cards[card.id].type"
                   :card="cards[card.id]">
        </component>
      </template>

    </main>

    <app-footer></app-footer>

  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import util from '@/functions'
export default {
  name: 'Page',
  props: ['id'],
  mounted () {
    if (util.isLoggedIn()) {
      this.LOAD_PARTICIPANT(this.$router)
    }
    this.loadPageData()
  },
  watch: {
    id () {
      this.loadPageData()
    }
  },
  data () {
    return {
      page: {}
    }
  },
  computed: {
    ...mapGetters([
      'pageDetails',
      'cards'
    ]),
    currentSpace () {
      return this.page.title || ''
    }
  },
  methods: {
    ...mapActions([
      'LOAD_PARTICIPANT',
      'LOAD_PAGE',
      'LOAD_CARD'
    ]),

    ...mapMutations([
      'UPDATE_CARD_DETAILS'
    ]),

    loadPageData: function () {
      let pageId = this.$route.meta.id
      this.LOAD_PAGE(pageId).then(() => {
        let cardIds = {}
        _.each(this.pageDetails[pageId].layout, (card) => {
          if (typeof this.cards[card.id] === 'undefined') {
            this.UPDATE_CARD_DETAILS({
              id: card.id,
              type: card.type,
              title: null,
              content: null
            })
          }
          cardIds[card.id] = card.id
        })
        this.page = this.pageDetails[pageId]
        _.each(cardIds, (id) => {
          this.LOAD_CARD({id: id})
        })
      }).catch(err => {
        this.$router.push({ name: 'NotFound' })
        return Promise.reject(err)
      })
      this.page = this.pageDetails[pageId]
        ? this.pageDetails[pageId]
        : {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// Page.vue?e9a2bed4